import { create } from "zustand";

// Limits on the return in progress that the till's posConfig doesn't carry.
// refundBlocked: the bill being returned was paid to the online store, so the
// till mustn't pay it back (Fashion: online orders go to store credit or an
// exchange). Kept in memory only: it belongs to the return on screen, and a
// reload starts the return again.
// onlyTypes: when set, the only ways (REFUND / STORE_CREDIT / EXCHANGE) the
// picked lines may be settled, e.g. an altered piece can only be exchanged.
// null leaves every configured way open.
const useReturnPolicyStore = create((set) => ({
  refundBlocked: false,
  setRefundBlocked: (refundBlocked) => set({ refundBlocked: Boolean(refundBlocked) }),
  onlyTypes: null,
  setOnlyTypes: (onlyTypes) => set({ onlyTypes: Array.isArray(onlyTypes) ? onlyTypes : null }),
}));

export default useReturnPolicyStore;
